import { createAxios } from "./axiosHttpMarconi";

export const chatsService = {
  get,
  deleteById,
  send,
};

function get(filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/chats`;
  const params = new URLSearchParams(filters);

  urlPath += `?${params.toString()}`;
  return axios.get(urlPath);
}

function deleteById(chatId) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/chats/${chatId}`;
  return axios.delete(urlPath);
}

function send(request) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/chats`;
  return axios.post(urlPath, request);
}
